module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Settings")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "light": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.attemptSave()
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-text-field', {
    attrs: {
      "append-icon": "clear",
      "label": "Delete Age (days)",
      "rules": [_vm.ruleRequired, _vm.rulePosInteger],
      "type": "number"
    },
    on: {
      "click:append": function (event) { return _vm.settings.daysDelete = 0; }
    },
    model: {
      value: (_vm.settings.daysDelete),
      callback: function($$v) {
        _vm.$set(_vm.settings, "daysDelete", _vm._n($$v))
      },
      expression: "settings.daysDelete"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "open-on-hover": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("help_outline")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._v("\n                  Images more than this many days old will be permanently deleted. "), _c('b', [_vm._v("Do not set this parameter unless you know what you are doing!")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.showSaveDialog),
      callback: function($$v) {
        _vm.showSaveDialog = $$v
      },
      expression: "showSaveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Save Changes?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to make changes to the settings?  Some settings may cause images to be irrevocably deleted.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSaveDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2938062","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 421
// module chunks = 1